export const FORM_MAP = {
  RANGE_TIME: 'rangeTime',
  RANGE_TIME_DIFF: 'diff',
  RANGE_TIME_TYPE: 'timeType',
  ZONE: 'zone',
  REGION: 'region',
  SYSTEM: 'system',
  LANGUAGE: 'language',
  CHANNEL: 'channel',
  IS_INIT: 'isInit'
}

export const styles = {
  "black": {
    borderColor: "black",//边框颜色
    backgroundColor: "black",//表盘背景色
    hourColor: "white",//小时数字颜色
    scaleColor: "black"//刻度线颜色
  },
  "white": {
    borderColor: "white",//边框颜色
    backgroundColor: "white",//表盘背景色
    hourColor: "black",//小时数字颜色
    scaleColor: "white"//刻度线颜色
  }
}

export const HEAT_COLUMN_KEYS = ["d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "d10", "d11", "d12", "d13", "d14", "d15", "d16", "d17", "d18", "d19", "d20", "d21", "d22", "d23", "d24", "d25", "d26", "d27", "d28", "d29", "d30", "d60", "d90"]

// 相关的本地文本
export const textLocalConfig = [
  {
    id: "common_date",
    key: "date",
  },
  {
    id: "common_Zone",
    key: "zone",
  },
  {
    id: "common_Region",
    key: "region",
  },
  {
    id: "common_Country",
    key: "country",
  },
  {
    id: "common_System",
    key: "system",
  },
  {
    id: "common_Channel",
    key: "channel",
  },
  {
    id: "common_Bundle",
    key: "bundle",
  },
  {
    id: "common_Sum",
    key: "sum",
  },
  {
    id: "common_Max",
    key: "max",
  },
  {
    id: "common_Min",
    key: "min",
  },
  {
    id: "common_Average",
    key: "avg",
  },
  {
    id: "common_Count",
    key: "count"
  },
  {
    id: "common_Average(remove_Null)",
    key: "avg_no_null",
  },
  {
    id: "common_Average(remove_Null&0)",
    key: "avg_no_null_zero"
  },
  {
    id: "common_timezone",
    key: "timezone"
  },
]

export const newUsersTimezoneTextLocalConfig = [
  {
    id: "new_users_retention_by_timezone_column_Register",
    key: "register"
  },
  {
    id: "new_users_retention_by_timezone_Retention_of_New_Users",
    key: "title"
  }
]
export const dailyTimezoneTextLocalConfig = [
  {
    id: "daily_by_timezone_Key_Metrics_Comparison",
    key: "tableTitle"
  }
]

export const VALUE_TYPE_RADIO_OPTIONS = ["value_only", "show_dod", "show_sdlw"]
